// Shared, client-safe types + helpers for admin-managed page SEO overrides.

export type PageSeoOverride = {
  path: string;
  title: string | null;
  description: string | null;
  og_title: string | null;
  og_description: string | null;
  og_image: string | null;
  canonical: string | null;
  noindex: boolean;
  updated_at?: string | null;
};

/**
 * Canonical form of a page path: lowercase, leading slash, no trailing slash
 * (except root), no query/hash. Both the writer (admin) and the reader (SSR)
 * normalise with this so lookups always match.
 */
export function normalizeSeoPath(input: string): string {
  let p = (input || "").trim();
  if (!p) return "/";
  // Accept a full URL and keep only the pathname.
  if (/^https?:\/\//i.test(p)) {
    try {
      p = new URL(p).pathname;
    } catch {
      /* fall through */
    }
  }
  p = p.split("?")[0]!.split("#")[0]!;
  if (!p.startsWith("/")) p = `/${p}`;
  p = p.toLowerCase();
  while (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p || "/";
}

export function isBlankOverride(o: Partial<PageSeoOverride>): boolean {
  return (
    !o.title &&
    !o.description &&
    !o.og_title &&
    !o.og_description &&
    !o.og_image &&
    !o.canonical &&
    !o.noindex
  );
}
